import { useState } from 'react';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';
import ChangePasswordPanel from './ChangePasswordPanel';

const PasswordChangeCard = ({ user }) => {
    const [isChangePasswordVisible, setIsChangePasswordVisible] = useState(false);
    const [isPasswordVisible, setIsPasswordVivible] = useState(false);
    const handleChangePasswordButtonClick = () => {
        setIsChangePasswordVisible(true);
    }

    const togglePasswordVisibility = () => {
        setIsPasswordVivible(!isPasswordVisible);
    }

    return (
        <div>
            <div className='row justify-content-center mt-2'>
                <div className='justify-content-center'>
                    <div>
                        <ChangePasswordPanel user={user} isChangePasswordVisible={isChangePasswordVisible} setIsChangePasswordVisible={setIsChangePasswordVisible} />
                        <div className='panel-header-title'>Twoje hasło</div>
                        <div className='col-auto ms-1'>
                            Aktualne hasło: <br />
                            <span style={{ fontWeight: 'bold', fontSize: '25px' }}>
                                {isPasswordVisible ? user.password : '*'.repeat(user.password.length)}
                            </span>
                            <button className='ms-2 ' style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }} onClick={togglePasswordVisibility}>
                                {isPasswordVisible ? <FaRegEyeSlash className='primary-accent-color-text' /> : <FaRegEye className='primary-accent-color-text' />}
                            </button>
                        </div>
                        <button className='btn-app-secondary mt-3' onClick={handleChangePasswordButtonClick}>
                            Zmień hasło
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PasswordChangeCard;